<template>
    <div>
        <b-form>
            <div class="row">
                <div class="col-12 col-sm-6">
                    <card-title-component :title="$t('speeches.persons.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <b-form-group id="funeral-oration-form-group"
                                              class="o-label"
                                              :label="$t('speeches.persons.burialSpeaker')"
                                              label-for="funeral-oration-input">
                                    <b-form-input id="funeral-oration-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localBurialSpeaker"
                                                  required
                                                  :placeholder="$t('speeches.persons.placeholder')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="foreword-form-group"
                                              class="o-label"
                                              :label="$t('speeches.persons.ceremonySpeaker')"
                                              label-for="foreword-input">
                                    <b-form-input id="foreword-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localCeremonySpeaker"
                                                  required
                                                  :placeholder="$t('speeches.persons.placeholder')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col button-div">
                                <b-button class="save-button o-button" v-on:click="save">
                                    {{$t('speeches.persons.saveButton')}}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <card-title-component :title="$t('speeches.documents.title')"></card-title-component>
                    <div class="card-content">
                        <file-upload-component :category="deathNoticeType" :title="titles.SPEECHES_TYPE_DEATH_NOTICE"></file-upload-component>
                        <file-upload-component :category="burialSpeechType" :title="titles.SPEECHES_TYPE_BURIAL_SPEECH"></file-upload-component>
                        <file-upload-component :category="ceremonySpeechType" :title="titles.SPEECHES_TYPE_CEREMONY_SPEECH"></file-upload-component>
                    </div>
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        SPEECHES_NAMESPACE,
        SPEECHES_TYPE_DEATH_NOTICE,
        SPEECHES_TYPE_BURIAL_SPEECH,
        SPEECHES_TYPE_CEREMONY_SPEECH,
        SPEECHES_GETTER,
        SPEECHES_MUTATION_SINGLE_ENTRY,
        SPEECHES_ACTION_GET_SPEECHES,
        SPEECHES_ACTION_SAVE_SPEECHES
    } from '../../store/modules/speeches-types'
    import TitleComponent from '../shared/TitleComponent'
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import FileUploadComponent from './FileUploadComponent'
    import i18n from '../../assets/i18n/lang'

    export default {
        name: 'Speeches',
        metaInfo () { return { title: i18n.t('speeches.meta') } },
        components: {
            'title-component': TitleComponent,
            'card-title-component': CardTitleComponent,
            'file-upload-component': FileUploadComponent
        },
        data () {
            return {
                deathNoticeType: SPEECHES_TYPE_DEATH_NOTICE,
                burialSpeechType: SPEECHES_TYPE_BURIAL_SPEECH,
                ceremonySpeechType: SPEECHES_TYPE_CEREMONY_SPEECH,
                titles: {
                    SPEECHES_TYPE_DEATH_NOTICE: i18n.t('speeches.documents.obituaryText'),
                    SPEECHES_TYPE_BURIAL_SPEECH: i18n.t('speeches.documents.funeralSpeechText'),
                    SPEECHES_TYPE_CEREMONY_SPEECH: i18n.t('speeches.documents.partySpeechText')
                }
            }
        },
        computed: {
            ...mapGetters(SPEECHES_NAMESPACE, {
                speeches: SPEECHES_GETTER
            }),
            localBurialSpeaker: {
                get () { return this.speeches.burialSpeaker },
                set (value) { this.updateSpeeches({burialSpeaker: value}) }
            },
            localCeremonySpeaker: {
                get () { return this.speeches.ceremonySpeaker },
                set (value) { this.updateSpeeches({ceremonySpeaker: value}) }
            },
            localDeathNotice: {
                get () { return this.speeches.deathNotice },
                set (value) { this.updateSpeeches({deathNotice: value}) }
            },
            localBurialSpeech: {
                get () { return this.speeches.burialSpeech },
                set (value) { this.updateSpeeches({burialSpeech: value}) }
            },
            localCeremonySpeech: {
                get () { return this.documents.ceremonySpeech },
                set (value) { this.updateSpeeches({ceremonySpeech: value}) }
            }
        },
        methods: {
            ...mapMutations(SPEECHES_NAMESPACE, {
                updateSpeeches: SPEECHES_MUTATION_SINGLE_ENTRY
            }),
            ...mapActions(SPEECHES_NAMESPACE, {
                loadSpeeches: SPEECHES_ACTION_GET_SPEECHES,
                saveSpeeches: SPEECHES_ACTION_SAVE_SPEECHES
            }),
            save () {
                this.saveSpeeches(this.speeches)
            },
            fileChosen (event) {
                console.log('bind: ' + this.test)
                console.log('event: ' + event.currentTarget.files[0].name)
                this.localDeathNoticeFile = this.$refs.fileInput.files[0]
                console.log('change: ' + this.localDeathNoticeFile.name)
                // console.log('file changed: ' + this.localDeathNoticeFile)
                // this.localDeathNoticeFile = this.$refs.fileInput
            }
        },
        created () {
            this.loadSpeeches()
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/funeral/SpeechesComponent.vue